<template>
  <div>
    <v-dialog v-model="postModel" width="900" persistent>
      <v-card-actions class="headline">
        <div class="headline">
          <span class="text-capitalize">{{ postDetails.title || "" }} </span>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col col="12">
                <v-card>
                  <!-- <view-image
                    default_image="default"
                    :height="300"
                  ></view-image> -->

                  <view-image
                    v-if="
                      postDetails.post_media &&
                        postDetails.post_media.length <= 1
                    "
                    :image="
                      postDetails.post_media[0]
                        ? postDetails.post_media[0].media
                        : null
                    "
                    defaultImage="default"
                    :height="300"
                  ></view-image>

                  <ImageSlider
                    v-else
                    :imageList="imageList"
                    :height="200"
                    :contain="true"
                  ></ImageSlider>
                </v-card>
                <v-row no-gutters class="mt-4">
                  <v-col md="6" class="pr-1 pb-2">
                    <v-btn
                      block
                      @click="showCommentedUsers(postDetails.id)"
                      color="#008483"
                      dark
                      >Comments</v-btn
                    >
                  </v-col>
                  <v-col md="6" class="pl-1 pb-2">
                    <v-btn
                      block
                      @click="showLikedUsers(postDetails.id)"
                      color="#008483"
                      dark
                      >Likes</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-card tile elevation="0">
                  <v-list class="transparent" dense>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Post Title</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ postDetails.title || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Description</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{ postDetails.description || "NA" }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Creator</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ postDetails.user || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Type</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{
                          (postDetails.is_public == 1 ? "Public" : "Private") ||
                            "NA"
                        }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Post Type</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            postDetails.post_type == "E"
                              ? "Event"
                              : postDetails.post_type == "S"
                              ? "Social"
                              : postDetails.post_type == "N"
                              ? "Normal"
                              : postDetails.post_type == "G"
                              ? "Games"
                              : ""
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Booking Type</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            postDetails.booking_type == "F" ? "Free" : "Hire"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <span class="users_tab_name"></span>
                      </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Location</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{ postDetails.location || "NA" }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Price</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{ postDetails.price || "NA" }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Payment Type</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        {{
                          postDetails.payment_type == "S" ? "Single" : "Group"
                        }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Start Date</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ postDetails.start_date || "" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >End Date</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            postDetails.end_date ? postDetails.end_date : "NA"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Duration</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ postDetails.duration || "NA" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Is shared</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            postDetails.shared_with_all_followers == 1
                              ? "Yes"
                              : "No"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Minimum Players</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ postDetails.minimum_players }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Participant Count</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ postDetails.participant_count }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Is Profile Completed</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            postDetails.is_profile_completed &&
                            postDetails.is_profile_completed == 1
                              ? "Yes"
                              : "No"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Status</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{ postDetails.status ? postDetails.status : "NA" }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon> </v-list-item-icon>
                      <v-list-item-subtitle class="text-left"
                        >Created at</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-black text-left">
                        <span class="text-capitalize"
                          >{{
                            postDetails.created_at
                              ? postDetails.created_at
                              : "NA"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color=" darken-1"
            class="ma-2 white--text green-color"
            text
            @click="
              () => {
                $emit('close');
                postModel = false;
              }
            "
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <liked-users-model
      v-bind="likedUsersModel"
      @close="likedUsersModel.postID = null"
    />
    <commented-users-model
      v-bind="commentedUsersModel"
      @close="commentedUsersModel.postID = null"
    />
  </div>
</template>

<script>
import LikedUsersModel from "./LikedUsersModel";
import CommentedUsersModel from "./CommentedUsersModel";
import ImageSlider from "../../../components/Image/ViewImageSlider.vue";
export default {
  components: {
    LikedUsersModel,
    CommentedUsersModel,
    ImageSlider,
  },
  props: {
    postID: { type: Number, default: null },
    type: { type: String, default: "details" },
  },
  data() {
    return {
      postModel: false,
      postDetails: {},
      image: null,
      menu: false,
      imageList: [],
      post: {},
      valid: false,
      creditList: [],
      page: 1,
      totalPages: 1,
      orderId: null,
      likedUsersModel: { postID: null, type: "details" },
      commentedUsersModel: { postID: null, type: "details" },
    };
  },
  watch: {
    postID(val) {
      if (val != null) {
        this.getpostDetails();
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {},
  computed: {},
  methods: {
    getpostDetails() {
      this.$http
        .get("posts/admin/post-details/" + this.postID)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.postDetails = response.data.data;
            this.imageList = [];
            this.postDetails.post_media.forEach((postMedia) => {
              this.imageList.push(postMedia.media);
            });

            this.postModel = true;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    closeAll() {
      this.postModel = false;
      this.valid = false;
      this.$emit("close");
    },

    showLikedUsers(postId) {
      this.likedUsersModel.postID = parseInt(postId);
      this.likedUsersModel.type = "details";
    },
    showCommentedUsers(postId) {
      this.commentedUsersModel.postID = parseInt(postId);
      this.commentedUsersModel.type = "details";
    },
  },
};
</script>

<style scoped>
.personal-trainer_ic {
  /* background-image: url("../../../assets/images/nav_icon/personal-trainer-grey.png"); */
  padding: 10px;
  background-size: contain;
}

.credit_table table thead tr th {
  background: #066a8c !important;
  color: #fff !important;
}
</style>
